var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRupaycard = function SvgRupaycard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text)",
    fillRule: "evenodd",
    d: "M0 5.312c0-1.974 0-2.96.42-3.697A3.2 3.2 0 0 1 1.615.42C2.352 0 3.338 0 5.312 0h23.376c1.974 0 2.96 0 3.698.42a3.2 3.2 0 0 1 1.194 1.195c.42.737.42 1.723.42 3.697v11.376c0 1.974 0 2.96-.42 3.698a3.2 3.2 0 0 1-1.194 1.194c-.738.42-1.724.42-3.698.42H5.312c-1.974 0-2.96 0-3.697-.42A3.2 3.2 0 0 1 .42 20.386C0 19.648 0 18.662 0 16.688zm28.542 7.169 1.251 2.487-2.63 2.488-.56 2.013 4.763-4.501-2.265-4.5zm.451 2.487-2.262-4.5-2.498 9z",
    clipRule: "evenodd"
  })));
};
export default SvgRupaycard;